import React, { useState } from 'react'
import { Container, Typography, Stack, Pagination, Switch, FormControlLabel } from '@mui/material'
import PostLoginV2 from '../../layout/postLoginV2'

import { MuiButton, MuiTextField, MuiSelect, Modal, MuiDialog, MuiCheckbox } from '../../components'

import { IconButton, Box } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import FolderIcon from '@mui/icons-material/Folder'

import { Fab } from '@mui/material'

import { Wrapper, ComponentWrapper } from './style'
import { CheckBox } from '@mui/icons-material'

const ThemePage = () => {
  const [isDark, setIsDark] = useState(false)
  const [textValue, setTextValue] = useState('Some text here')
  const [selectValue, setSelectValue] = useState('')
  const [checked, setChecked] = useState(false)
  const [openPopup, setOpenPopup] = useState(false)
  const [isDisabled, setDisabled] = useState(false)
  const [isActive, setActive] = useState(false)
  const [isCheckboxChecked, setIsCheckboxChecked] = useState([
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
  ])

  const toggleTheme = () => setIsDark((prev) => !prev)

  const colors = [
    'primary',
    'dark',
    'gray',
    'light',
    'error',
    'warning',
    'success',
    'secondary',
    'info',
    'default',
  ]

  return (
    <PostLoginV2>
      <Container>
        <ComponentWrapper>
          <MuiButton
            variant='contained'
            onClick={() => setDisabled(!isDisabled)}
            label='isDisabled'
          />
          <MuiButton variant='contained' onClick={() => setActive(!isActive)} label='isActive' />
        </ComponentWrapper>
      </Container>

      <Container>
        <ComponentWrapper>
          <Typography variant='h6' gutterBottom>
            Selectbox
          </Typography>
          <MuiSelect
            name={'subAttribute'}
            styletype='themeV2'
            onChange={(e) => console.log({ label: e.target.value, value: e.target.value })}
            data={[
              { value: 'option1', label: 'Option 1' },
              { value: 'option2', label: 'Option 2' },
            ]}
            compact
            placeholder='Sub Attribute'
            selectlabel='label'
            selectvalue='value'
            value={'option1'}
            style={{ width: '150px' }}
          />
        </ComponentWrapper>

        <ComponentWrapper>
          <Typography variant='h6' gutterBottom>
            Contained Button
          </Typography>
          <Stack direction='row' spacing={2} mb={4}>
            {colors.map((color) => (
              <MuiButton
                className={isActive ? 'active' : ''}
                key={color}
                variant='contained'
                color={color === 'default' ? undefined : color}
                disabled={isDisabled}
              >
                {color.charAt(0).toUpperCase() + color.slice(1)}
              </MuiButton>
            ))}
          </Stack>
        </ComponentWrapper>

        <ComponentWrapper>
          <Typography variant='h6' gutterBottom>
            Outlined Button
          </Typography>
          <Stack direction='row' spacing={2} mb={4}>
            {colors.map((color) => (
              <MuiButton
                className={isActive ? 'active' : ''}
                key={color}
                variant='outlined'
                color={color === 'default' ? undefined : color}
                disabled={isDisabled}
              >
                {color.charAt(0).toUpperCase() + color.slice(1)}
              </MuiButton>
            ))}
          </Stack>
        </ComponentWrapper>

        <ComponentWrapper>
          <Typography variant='h6' gutterBottom>
            Text Button
          </Typography>
          <Stack direction='row' spacing={2} mb={4}>
            {colors.map((color) => (
              <MuiButton
                className={isActive ? 'active' : ''}
                key={color}
                variant='text'
                color={color === 'default' ? undefined : color}
                disabled={isDisabled}
              >
                {color.charAt(0).toUpperCase() + color.slice(1)}
              </MuiButton>
            ))}
          </Stack>
        </ComponentWrapper>

        <ComponentWrapper>
          <Typography variant='h6' gutterBottom>
            Only Icon
          </Typography>
          <Stack direction='row' spacing={2} mb={4}>
            <MuiButton
              className={isActive ? 'active' : ''}
              size='small'
              variant='contained'
              startIcon={<AddIcon />}
            ></MuiButton>
            <MuiButton
              className={isActive ? 'active' : ''}
              size='small'
              variant='outlined'
              endIcon={<AddIcon />}
            ></MuiButton>
            <MuiButton
              className={isActive ? 'active' : ''}
              size='small'
              variant='text'
              endIcon={<AddIcon />}
            ></MuiButton>
            <MuiButton
              className={isActive ? 'active' : ''}
              variant='contained'
              startIcon={<AddIcon />}
            ></MuiButton>
            <MuiButton
              className={isActive ? 'active' : ''}
              variant='outlined'
              endIcon={<AddIcon />}
            ></MuiButton>
            <MuiButton
              className={isActive ? 'active' : ''}
              variant='text'
              endIcon={<AddIcon />}
            ></MuiButton>
            <MuiButton
              className={isActive ? 'active' : ''}
              size='large'
              variant='contained'
              startIcon={<AddIcon />}
            ></MuiButton>
            <MuiButton
              className={isActive ? 'active' : ''}
              size='large'
              variant='outlined'
              endIcon={<AddIcon />}
            ></MuiButton>
            <MuiButton
              className={isActive ? 'active' : ''}
              size='large'
              variant='text'
              endIcon={<AddIcon />}
            ></MuiButton>
          </Stack>
        </ComponentWrapper>

        <ComponentWrapper>
          <Typography variant='h6' gutterBottom>
            With Icon
          </Typography>
          <Stack direction='row' spacing={2} mb={4}>
            {colors.map((color , index) => (
              <MuiButton
                className={isActive ? 'active' : ''}
                key={color}
                variant={index === 1 || index === 4 || index === 7 ? 'outlined' : index === 2 || index === 5 || index === 8 ? 'text' : 'contained' }
                color={color === 'default' ? undefined : color}
                disabled={isDisabled}
                startIcon={index % 2 === 0 ? <AddIcon /> : ''}
                endIcon={index % 2 !== 0  ? <AddIcon /> : ''}
              >
                {color.charAt(0).toUpperCase() + color.slice(1)}
              </MuiButton>
            ))}
            {/* <MuiButton
              className={isActive ? 'active' : ''}
              variant='contained'
              startIcon={<AddIcon />}
            >
              Icon Start
            </MuiButton>
            <MuiButton
              className={isActive ? 'active' : ''}
              variant='outlined'
              endIcon={<AddIcon />}
            >
              Icon End
            </MuiButton>
            <MuiButton className={isActive ? 'active' : ''} variant='text' endIcon={<AddIcon />}>
              Icon End With Text
            </MuiButton> */}
          </Stack>
        </ComponentWrapper>

        <ComponentWrapper>
          <Typography variant='h6' gutterBottom>
            Icon Button
          </Typography>
          <Stack direction='row' spacing={2} mb={4}>
            {colors.map((color) => (
              <IconButton key={color} color={color === 'default' ? undefined : color}>
                <FolderIcon />
              </IconButton>
            ))}
          </Stack>
        </ComponentWrapper>

        <ComponentWrapper>
          <Typography variant='h6' gutterBottom>
            Sizes
          </Typography>
          <Stack direction='row' spacing={2} mb={4}>
            <MuiButton
              className={isActive ? 'active' : ''}
              variant='contained'
              size='large'
              color='primary'
            >
              Large
            </MuiButton>
            <MuiButton
              className={isActive ? 'active' : ''}
              variant='contained'
              size='medium'
              color='primary'
            >
              Medium
            </MuiButton>
            <MuiButton
              className={isActive ? 'active' : ''}
              variant='contained'
              size='small'
              color='primary'
            >
              Small
            </MuiButton>

            <MuiButton
              className={isActive ? 'active' : ''}
              variant='outlined'
              size='large'
              color='primary'
            >
              Large
            </MuiButton>
            <MuiButton
              className={isActive ? 'active' : ''}
              variant='outlined'
              size='medium'
              color='primary'
            >
              Medium
            </MuiButton>
            <MuiButton
              className={isActive ? 'active' : ''}
              variant='outlined'
              size='small'
              color='primary'
            >
              Small
            </MuiButton>

            <MuiButton
              className={isActive ? 'active' : ''}
              variant='text'
              size='large'
              color='primary'
            >
              Large
            </MuiButton>
            <MuiButton
              className={isActive ? 'active' : ''}
              variant='text'
              size='medium'
              color='primary'
            >
              Medium
            </MuiButton>
            <MuiButton
              className={isActive ? 'active' : ''}
              variant='text'
              size='small'
              color='primary'
            >
              Small
            </MuiButton>
          </Stack>
        </ComponentWrapper>
      </Container>

      <Container>
        <Box p={4}>
          <Typography variant='h6' gutterBottom>
            Default
          </Typography>
          <Stack direction='row' spacing={2} mb={4}>
            {colors.map((color) => (
              <Fab key={color} color={color === 'default' ? undefined : color} size='medium'>
                <AddIcon />
              </Fab>
            ))}
          </Stack>

          <Typography variant='h6' gutterBottom>
            Extended
          </Typography>
          <Stack direction='row' spacing={2} mb={4}>
            {colors.map((color) => (
              <Fab key={color} variant='extended' color={color === 'default' ? undefined : color}>
                <AddIcon sx={{ mr: 1 }} />
                {color.charAt(0).toUpperCase() + color.slice(1)}
              </Fab>
            ))}
          </Stack>

          <Typography variant='h6' gutterBottom>
            Sizes
          </Typography>
          <Stack direction='row' spacing={2} mb={4}>
            <Fab color='primary' size='small'>
              <AddIcon />
            </Fab>
            <Fab color='primary' size='medium'>
              <AddIcon />
            </Fab>
            <Fab color='primary' size='large'>
              <AddIcon />
            </Fab>
          </Stack>

          <ComponentWrapper>
            <Typography variant='h6' gutterBottom>
              MuiCheckbox
            </Typography>
            <Stack direction='row' spacing={2} mb={4}>
              <MuiCheckbox
                styling='themeV2'
                checked={isCheckboxChecked[0]}
                onChange={(e) => {
                  const newChecked = [...isCheckboxChecked]
                  newChecked[0] = e.checked
                  setIsCheckboxChecked(newChecked)
                }}
                className={isActive ? 'active' : ''}
                label='ThemeV2'
                disabled={isDisabled}
                size='large'
              />
              <MuiCheckbox
                checked={isCheckboxChecked[1]}
                onChange={(e) => {
                  const newChecked = [...isCheckboxChecked]
                  newChecked[1] = e.target.checked
                  setIsCheckboxChecked(newChecked)
                }}
                className={isActive ? 'active' : ''}
                label='Default'
                iconType='default'
                disabled={isDisabled}
                size='medium'
                color='default'
              />
              {/* <MuiCheckbox className={isActive ? 'active' : ''} label='Small' iconType='default' disabled={isDisabled} size='small' color='primary' /> */}
              <MuiCheckbox
                checked={isCheckboxChecked[2]}
                onChange={(e) => {
                  const newChecked = [...isCheckboxChecked]
                  newChecked[2] = e.target.checked
                  setIsCheckboxChecked(newChecked)
                }}
                className={isActive ? 'active' : ''}
                label='Large'
                variant='contained'
                disabled={isDisabled}
                size='large'
                color='primary'
              />
              <MuiCheckbox
                checked={isCheckboxChecked[3]}
                onChange={(e) => {
                  const newChecked = [...isCheckboxChecked]
                  newChecked[3] = e.target.checked
                  setIsCheckboxChecked(newChecked)
                }}
                className={isActive ? 'active' : ''}
                label='Medium'
                variant='contained'
                disabled={isDisabled}
                size='medium'
                color='error'
              />
              <MuiCheckbox
                checked={isCheckboxChecked[4]}
                onChange={(e) => {
                  const newChecked = [...isCheckboxChecked]
                  newChecked[4] = e.target.checked
                  setIsCheckboxChecked(newChecked)
                }}
                className={isActive ? 'active' : ''}
                label='Small'
                variant='contained'
                disabled={isDisabled}
                size='small'
                color='warning'
              />
              <MuiCheckbox
                checked={isCheckboxChecked[5]}
                onChange={(e) => {
                  const newChecked = [...isCheckboxChecked]
                  newChecked[5] = e.target.checked
                  setIsCheckboxChecked(newChecked)
                }}
                variant='outlined'
                className={isActive ? 'active' : ''}
                label='Large'
                disabled={isDisabled}
                size='large'
                color='primary'
              />
              <MuiCheckbox
                checked={isCheckboxChecked[6]}
                onChange={(e) => {
                  const newChecked = [...isCheckboxChecked]
                  newChecked[6] = e.target.checked
                  setIsCheckboxChecked(newChecked)
                }}
                variant='outlined'
                className={isActive ? 'active' : ''}
                label='Medium'
                disabled={isDisabled}
                size='medium'
                color='error'
              />
              <MuiCheckbox
                checked={isCheckboxChecked[7]}
                onChange={(e) => {
                  const newChecked = [...isCheckboxChecked]
                  newChecked[7] = e.target.checked
                  setIsCheckboxChecked(newChecked)
                }}
                variant='outlined'
                className={isActive ? 'active' : ''}
                label='Small'
                disabled={isDisabled}
                size='small'
                color='warning'
              />
            </Stack>
          </ComponentWrapper>
        </Box>
      </Container>

      <Container sx={{ mt: 4 }}>
        <div style={{ display: 'none' }}>
          <Typography variant='h4' gutterBottom align='center'>
            {isDark ? 'Dark' : 'Light'} Theme Page
          </Typography>

          <Wrapper>
            <MuiButton
              className={isActive ? 'active' : ''}
              label='Change Theme'
              onClick={toggleTheme}
            />
          </Wrapper>

          <Typography variant='h6'>TextField Variants</Typography>

          <MuiTextField title='Current Verbatim' value={'Current Verbatim'} inputType='area' />

          <MuiTextField
            error={true}
            fullWidth
            helperText={'help text'}
            label='Draft Name'
            name='draftName'
            onChange={(e) => console.log(e.target.value)}
            value={'Draft Name'}
            variant='standard'
          />

          <MuiTextField
            title='YourName'
            value={textValue}
            onChange={(e) => setTextValue(e.target.value)}
          />
          <MuiTextField
            title='Outlined'
            variant='outlined'
            value={textValue}
            onChange={(e) => setTextValue(e.target.value)}
          />
          <MuiTextField
            title='Small'
            size='small'
            value={textValue}
            onChange={(e) => setTextValue(e.target.value)}
          />
          <MuiTextField
            title='Medium'
            size='medium'
            value={textValue}
            onChange={(e) => setTextValue(e.target.value)}
          />
          <MuiTextField
            title='Large'
            size='large'
            value={textValue}
            onChange={(e) => setTextValue(e.target.value)}
          />

          <Typography variant='h6'>Select Variants</Typography>
          <MuiSelect
            label='Select Option'
            value={selectValue}
            onChange={(e) => setSelectValue(e.target.value)}
            styletype='themeV2'
            options={[
              { value: 'option1', label: 'Option 1' },
              { value: 'option2', label: 'Option 2' },
            ]}
          />

          <MuiSelect
            name='driverName'
            onChange={(e) => console.log(e.target.name, e.target.value)}
            title='Driver'
            data={[
              { value: 'option1', label: 'Option 1' },
              { value: 'option2', label: 'Option 2' },
            ]}
            compact
            // disabled={!entityName}
            placeholder='Select'
            variant={'outlined'}
            // value={value || null}
          />

          <Typography variant='h6'>Pagination</Typography>
          <Pagination count={10} color='primary' />

          <Typography variant='h6'>Switch</Typography>
          <FormControlLabel
            control={<Switch checked={checked} onChange={(e) => setChecked(e.target.checked)} />}
            label='Enable Feature'
          />

          <MuiButton
            className={isActive ? 'active' : ''}
            label='Show Popup'
            onClick={() => setOpenPopup(true)}
          />
        </div>

        {openPopup && (
          <Modal
            title='This is text content'
            showClose={openPopup}
            onClose={() => setOpenPopup(false)}
          >
            <b>This is text content ... </b>
          </Modal>
        )}

        <MuiDialog buttonName='click Here'>Some content will come here</MuiDialog>
      </Container>
    </PostLoginV2>
  )
}

export default ThemePage
